import React from "react";
import Tr from "../../common/table/tr";
import Td from "../../common/table/td";
import TableInCell from "../../common/table/tableInCell";
import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar";

export function RodapeTotaisFaturaEnergia({ totais }) {
    return (
        <Tr>
            <Td fontSize="0.85rem" fontWeight="bold">
                Total
            </Td>
            <Td fontSize="0.85rem" fontWeight="bold">
                Qtd. UC:{totais.quantidadeUnidadesFiltradas}
            </Td>
            <Td fontSize="0.85rem" fontWeight="bold">
                <TableInCell
                    lista={[
                        { cabecalho: "Produção (kWh)", valor: adicionarPontosMilhar(totais.totalProducaoSolar || 0) },
                        { cabecalho: "Saldo Produção (kWh)", valor: adicionarPontosMilhar(totais.totalSaldo || 0), width: 95 },
                        { cabecalho: "Injetado/Excedente (kWh)", valor: adicionarPontosMilhar(totais.totalEnergiaExcedente || 0) },
                    ]}
                />
            </Td>
            <Td fontSize="0.85rem" colSpan={6} fontWeight="bold"></Td>
            <Td fontSize="0.85rem" fontWeight="bold">
                <TableInCell
                    lista={[
                        { cabecalho: "PIS/PASEP (R$)", valores: [" - ", adicionarPontosMilhar(totais.totalValorPisPasep || 0)] },
                        { cabecalho: "COFINS (R$)", valores: [" - ", adicionarPontosMilhar(totais.totalValorCofins || 0)] },
                        { cabecalho: "ICMS (R$)", valores: [" - ", adicionarPontosMilhar(totais.totalValorIcms || 0)] },
                    ]}
                />
            </Td>
            <Td fontSize="0.85rem" fontWeight="bold">
                <TableInCell
                    lista={[
                        { cabecalho: "Custo de Energia ACL (R$)", valor: adicionarPontosMilhar(totais.totalCustoEnergiaACL || 0) },
                        { cabecalho: "Custo de Gestão ACL (R$)", valor: adicionarPontosMilhar(totais.totalCustoGestaoACL || 0) },
                        { cabecalho: "Tx. de Contribuição CCEE (R$)", valor: adicionarPontosMilhar(totais.totalContribuicaoAssociativaCCEE || 0) },
                    ]}
                />
            </Td>
            <Td fontSize="0.85rem" fontWeight="bold">
                <TableInCell
                    lista={[
                        { cabecalho: "Fatura (R$)", valor: adicionarPontosMilhar(totais.totalValorFatura || 0) },
                        { cabecalho: "Importado (R$)", valor: adicionarPontosMilhar(totais.totalValorImportado || 0) },
                    ]}
                />
            </Td>
            <Td fontSize="0.85rem" fontWeight="bold">
                <TableInCell
                    lista={[
                        { cabecalho: "Total (kWh)", valor: adicionarPontosMilhar(totais.totalenergia || 0) },
                        { cabecalho: "Ponta (kWh)", valor: adicionarPontosMilhar(totais.totalEnergiaPonta || 0) },
                        { cabecalho: "Fora Ponta (kWh)", valor: adicionarPontosMilhar(totais.totalEnergiaForaPonta || 0) },
                        { cabecalho: "Reservado (kWh)", valor: adicionarPontosMilhar(totais.totalEnergiaReservado || 0) },
                    ]}
                />
            </Td>
            <Td fontSize="0.85rem" fontWeight="bold">
                <TableInCell
                    lista={[
                        { cabecalho: "Fora Ponta Contrato Cadastro (kW)", valor: adicionarPontosMilhar(totais.totalDemandaContratadaFpContrato || 0) },
                        { cabecalho: "Fora Ponta Contrato Fatura (kW)", valor: adicionarPontosMilhar(totais.totalDemandaContratadaFpFatura || 0) },
                        { cabecalho: "Ponta Contrato Cadastro (kW)", valor: adicionarPontosMilhar(totais.totalDemandaContratadaPContrato || 0) },
                        { cabecalho: "Ponta Contrato Fatura (kW)", valor: adicionarPontosMilhar(totais.totalDemandaContratadaPFatura || 0) },
                    ]}
                />
            </Td>
            <Td fontSize="0.85rem" fontWeight="bold">
                <TableInCell
                    lista={[
                        {
                            cabecalho: "Ponta",
                            valores: [adicionarPontosMilhar(totais.totalDemandaPonta || 0) + " kW", "R$ " + adicionarPontosMilhar(totais.totalValorDemandaPonta || 0)],
                        },
                        {
                            cabecalho: "Fora Ponta",
                            valores: [adicionarPontosMilhar(totais.totalDemanda || 0) + " kW", "R$ " + adicionarPontosMilhar(totais.totalValorDemanda || 0)],
                        },
                        {
                            cabecalho: "Reservado",
                            valores: [adicionarPontosMilhar(totais.totalDemandaReservado || 0) + " kW", "R$ " + adicionarPontosMilhar(totais.totalValorDemandaReservado || 0)],
                        },
                        {
                            cabecalho: "Demanda G",
                            valores: [adicionarPontosMilhar(totais.totalDemandaGeracao || 0) + " kW", "R$ " + adicionarPontosMilhar(totais.totalValorDemandaGeracao || 0)],
                        },
                    ]}
                />
            </Td>
            <Td fontSize="0.85rem" fontWeight="bold" alignCenter>
                {adicionarPontosMilhar(totais.totalEnergiaReativo || 0)}
            </Td>
            <Td fontSize="0.85rem" fontWeight="bold" alignCenter>
                {adicionarPontosMilhar(totais.totalGastoReativo || 0)}
            </Td>
            <Td fontSize="0.85rem"></Td>
            <Td fontSize="0.85rem"></Td>
            <Td fontSize="0.85rem"></Td>
        </Tr>
    );
}
